import React from 'react';
import { Link } from 'react-router-dom';
import { FeedShape } from '../shapes';
import DateMaster from '../stores/utils/date_master';

export default class FollowsFeed extends React.Component {
  static propTypes = {
    feed: FeedShape
  }

  render() {
    if (this.props.feed.get('followsFeed').size > 0) {
      return this.renderFollowsFeed();
    } else {
      return null;
    }
  }

  renderFollowsFeed() {
    const feedItems = this.props.feed.get('followsFeed').map((feedItem, i) => {
      return this.renderFeedItem(feedItem, i);
    });

    return(
      <div className='follows-feed trending-words'>
        <h3>
          Words from People you Follow
        </h3>
        <ul className='list-group'>
            { feedItems }
        </ul>
      </div>
    );
  }

  renderFeedItem(feedItem, index) {
    const name = feedItem.get('userName') || feedItem.get('userSlug');
    return (
      <li key={ index } className='list-group-item feed-item'>
        <div className='row'>
          <div className='col-12'>
            <Link to={ `/words/${feedItem.get('wordText')}` } className='word-text'>{ feedItem.get('wordText') }</Link>
          </div>
        </div>
        <div className='row'>
          <div className='col-6 item-meta'>
            <Link to={ `/people/${ feedItem.get('userSlug') }` }>{ name }</Link>
          </div>
          <div className='col-6 item-meta'>
            { DateMaster.format(feedItem.get('createdAt')) }
          </div>
        </div>
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/follows_feed.jsx